<template>
  <input
    ref="inputRef"
    :value="formattedValue"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
    style="
      border-radius: 4px;
      border: 1px solid #757575;
      padding: 5px;
      width: 99%;
      font-size: initial;
    "
  />
</template>

<script>
export default {
  name: 'CurrencyInput',
  props: {
    value: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: () => ({
        locale: 'de-DE',
        currency: 'EUR',
        currencyDisplay: 'symbol',
        precision: 2
      })
    }
  },
  data () {
    return {
      isFocused: false,
      inputValue: this.value || 0
    }
  },
  computed: {
    formattedValue () {
      if (this.isFocused) {
        return this.inputValue
      }
      const opts = this.options || {}
      return new Intl.NumberFormat(opts.locale || 'de-DE', {
        style: 'currency',
        currency: opts.currency || 'EUR',
        minimumFractionDigits: opts.precision || 2,
        maximumFractionDigits: opts.precision || 2
      }).format(this.inputValue || 0)
    }
  },
  watch: {
    value (newVal) {
      if (newVal !== this.inputValue) {
        this.inputValue = newVal || 0
      }
    }
  },
  methods: {
    onInput (event) {
      const val = event.target.value.replace(/[^0-9.,]/g, '').replace(',', '.')
      const numVal = parseFloat(val) || 0
      this.inputValue = numVal
      this.$emit('input', numVal)
    },
    onFocus () {
      this.isFocused = true
      this.$nextTick(() => {
        this.$refs.inputRef.value = this.inputValue
      })
    },
    onBlur () {
      this.isFocused = false
      this.$emit('blur')
    }
  }
}
</script>
